export function initAddTagsModal() {
  const element = document.getElementById("searchAddTagsModal");
  return element ? new bootstrap.Modal(element) : null;
}

export function showAddTagsModal(modal, slug, name, { onApply, onSkip }) {
  if (!modal) {
    onSkip();
    return;
  }

  document.getElementById("searchAddTagsContentName").textContent = name;

  document
    .querySelectorAll("#searchAddTagsModal .search-tag-checkbox")
    .forEach((cb) => (cb.checked = false));

  document.getElementById("searchAddTagsConfirmBtn").onclick = () => {
    const checkboxes = document.querySelectorAll(
      "#searchAddTagsModal .search-tag-checkbox:checked",
    );
    if (checkboxes.length === 0) {
      onSkip();
      return;
    }
    onApply(checkboxes);
  };

  document.getElementById("searchAddTagsSkipBtn").onclick = onSkip;

  modal.show();
}

export function applyContentTags(slug, checkboxes) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
  const confirmBtn = document.getElementById("searchAddTagsConfirmBtn");
  confirmBtn.disabled = true;

  const promises = Array.from(checkboxes).map((cb) =>
    fetch(`/content/${slug}/tags/${cb.dataset.tagId}`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest",
      },
    }),
  );

  return Promise.all(promises).then(() => {
    confirmBtn.disabled = false;
  });
}

export function executeAddToLibrary(slug, { skipEvent = false } = {}) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

  return fetch(`/content/${slug}/add-to-library`, {
    method: "POST",
    headers: {
      "X-CSRF-Token": csrfToken,
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: skipEvent ? "skip_event=true" : "",
  }).then((response) => response.json());
}

export function removeFromLibrary(slug) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

  return fetch(`/content/${slug}/remove-from-library`, {
    method: "DELETE",
    headers: {
      "X-CSRF-Token": csrfToken,
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then((response) => response.json());
}

export function setAddButtonState(btn, controllerName) {
  btn.classList.add("in-library");
  btn.innerHTML =
    '<i class="bi bi-check-lg search-in-library-default-icon"></i><i class="bi bi-trash search-in-library-hover-icon"></i>';
  btn.dataset.action = `click->${controllerName}#removeFromLibrary`;
  btn.disabled = false;
}

export function setRemoveButtonState(btn, controllerName) {
  btn.classList.remove("in-library");
  btn.innerHTML = '<i class="bi bi-plus-lg"></i>';
  btn.dataset.action = `click->${controllerName}#addToLibrary`;
}
